import { graphql } from "gql/apollo";

export const UpdateIntegration = graphql(/* GraphQL */ `
	mutation UpdateGenetecIntegrationByGID(
		$params: UpdateGenetecIntegrationByGIDParams!
	) {
		updateGenetecIntegrationByGID(params: $params) {
			integration: genetecIntegration {
				...GenetecIntegrationFields
			}
			error {
				message
			}
			success
		}
	}
`);
